export class InputSelectHelper {
	static getIntervals(): { [key: string]: string | number }[] {
		return [
			{
				label: '1 min',
				value: 1,
				icon: '',
			},
			{
				label: '5 min',
				value: 5,
				icon: '',
			},
			{
				label: '15 min',
				value: 15,
				icon: '',
			},
			{
				label: '30 min',
				value: 30,
				icon: '',
			},
			{
				label: '1h',
				value: 60,
				icon: '',
			},
			{
				label: '2h',
				value: 120,
				icon: '',
			},
			{
				label: '4h',
				value: 240,
				icon: '',
			},
			{
				label: '8h',
				value: 480,
				icon: '',
			},
			{
				label: '24h',
				value: 1440,
				icon: '',
			},
			{
				label: '1 t',
				value: 10080,
				icon: '',
			},
			{
				label: '1 m',
				value: 43200,
				icon: '',
			},
		];
	}

	static getDays(): { [key: string]: string }[] {
		return [
			{
				label: '1 d',
				value: '1',
				icon: '',
			},
			{
				label: '1 t',
				value: '7',
				icon: '',
			},
			{
				label: '1 m',
				value: '30',
				icon: '',
			},
			{
				label: '6 m',
				value: '180',
				icon: '',
			},
			{
				label: '1 r',
				value: '365',
				icon: '',
			},
		];
	}
}
